import React from 'react';
import { Link } from 'react-router-dom';
import styles from './LegalPage.module.css';

function PrivacyPage() {
  return (
    <div className={styles.legalPage}>
      <div className={styles.container}>
        <h1>Privacy Policy</h1>
        <p className={styles.lastUpdated}>Last updated: 1/17/26</p>

        <section className={styles.section}>
          <p>
            Ragged Spade LLC operates a portfolio of applications and services, including but not limited to
            Compyz, Beat Clicker, and Fixscope (collectively, the "Apps").
          </p>
          <p>This Privacy Policy explains how information is handled when using the Apps.</p>
        </section>

        <section className={styles.section}>
          <h2>1. Information Collected</h2>

          <h3>Personal Information</h3>
          <p>The Apps do not require users to create accounts or submit personal information to function.</p>
          <p>If a user contacts support, the following information may be received:</p>
          <ul>
            <li>Email address</li>
            <li>Message content</li>
          </ul>
          <p>This information is used only to respond to the request.</p>

          <h3>Non-Personal Information</h3>
          <p>The Apps may automatically collect limited technical information, including:</p>
          <ul>
            <li>Device type</li>
            <li>Operating system version</li>
            <li>App version</li>
            <li>Crash and performance diagnostics</li>
          </ul>
          <p>This data is used solely to improve stability and performance.</p>
        </section>

        <section className={styles.section}>
          <h2>2. Purchases</h2>
          <p>
            Some Apps offer optional in-app purchases. All payments are processed by Apple's App Store.
            Ragged Spade LLC does not collect or store payment or billing information.
          </p>
        </section>

        <section className={styles.section}>
          <h2>3. Use of Information</h2>
          <p>Information is used only to:</p>
          <ul>
            <li>Operate and improve the Apps</li>
            <li>Diagnose errors and crashes</li>
            <li>Provide customer support</li>
            <li>Enable in-app purchase functionality</li>
          </ul>
          <p>Information is not sold, rented, or shared for advertising purposes.</p>
        </section>

        <section className={styles.section}>
          <h2>4. Third-Party Services</h2>
          <p>The Apps may rely on third-party services strictly for functionality, including:</p>
          <ul>
            <li>Apple App Store and In-App Purchases</li>
            <li>Purchase management or analytics tools</li>
          </ul>
          <p>These services operate under their own privacy policies.</p>
        </section>

        <section className={styles.section}>
          <h2>5. Children's Privacy</h2>
          <p>
            The Apps do not knowingly collect personal information from children under the age of 13.
            If personal information is believed to have been collected unintentionally, it will be
            removed upon request.
          </p>
        </section>

        <section className={styles.section}>
          <h2>6. User Rights</h2>
          <p>
            Users may contact Ragged Spade LLC regarding questions or concerns about privacy or data handling.
          </p>
        </section>

        <section className={styles.section}>
          <h2>7. Policy Changes</h2>
          <p>
            This Privacy Policy may be updated periodically. Changes will be posted with a revised date.
          </p>
        </section>

        <section className={styles.section}>
          <h2>Contact Information</h2>
          <p>
            Email: <a href="mailto:admin@raggedspade.com">admin@raggedspade.com</a>
          </p>
          <p>
            Website: <a href="https://raggedspade.com">https://raggedspade.com</a>
          </p>
        </section>

        <div className={styles.backLink}>
          <Link to="/">← Back to Home</Link>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPage;
